import HeroCollegeTitle from "./HeroCollegeTitle";
import Swiper from 'swiper/swiper-bundle';
import HeadshotCollegeCard from "./HeadshotCollegeCard";

class PageCollegeTalent {
    constructor() {
        this.initHero();
        this.initCarousels();
        this.initHeadshotCards();
    }

    initHero() {
        const mainHero = document.getElementById("college-talent-hero");
        if (mainHero) {
            const heroHeading = mainHero.querySelector(".college-heading--title");

            if(heroHeading) {
                const title = new HeroCollegeTitle(heroHeading);
            }
        }
    }

    updateSlidesStyle(e) {
        for (let r = 0; r < e.slides.length; r += 1) {
            const slide = e.slides[r].firstElementChild;
            const text = slide.nextElementSibling;
            const dataOverlay = slide.querySelector('.data-overlay');
            const progress = e.slides[r].progress;
            const absProgress = Math.abs(progress);

            let opacitySecondary = 1 - absProgress;
            opacitySecondary = opacitySecondary < 0 ? 0 : opacitySecondary;

            let scale = Math.round((1.05 - 0.45 * absProgress) * 100) / 100;
            scale = scale > 0.57 ? scale : 0.57;

            slide.style.transform = `matrix3d(${scale}, 0, 0, 0, 0, ${scale}, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)`;

            text.style.opacity = opacitySecondary;
            dataOverlay.style.opacity = opacitySecondary;
        }
    }

    updateTransitionStyle(e, t) {
        for (let r = 0; r < e.slides.length; r += 1) {
            const slide = e.slides[r].firstElementChild;
            const text = slide.nextElementSibling;
            const dataOverlay = slide.querySelector('.data-overlay');

            slide.style.transitionDuration = `${t}ms`;
            text.style.transitionDuration = `${t}ms`;
            dataOverlay.style.transitionDuration = `${t}ms`;
        }
    }

    initCarousels() {
        const that = this;
        var swiperCollegeDataSlider = new Swiper(".college-talent-data-slider", {
            slidesPerView: '1',
            spaceBetween: 24,
            centeredSlides: true,
            watchOverflow: true,
            loop: true,
            watchSlidesProgress: true,
            allowTouchMove: true,
            loopAdditionalSlides: 10,
            speed: 800,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },

            breakpoints: {
                768: {
                    slidesPerView: '3',
                },
            },
            on: {
                progress(e) {
                    that.updateSlidesStyle(e);
                },
                setTransition(e, t) {
                    that.updateTransitionStyle(e, t);
                }
            }
        });

        var swiperCollegeBannerSlider = new Swiper(".college-talent-banner-slider", {
            slidesPerView: '1',
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            loop: true,
            effect: "fade",
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
        });

        var swiperCollegeSlider = new Swiper('.college-event-slider', {
            slidesPerView: 'auto',
            spaceBetween: 24,
        });

        var swiperStudentStoriesSlider = new Swiper(".student-stories-slider", {
            slidesPerView: 'auto',
            spaceBetween: 22,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: '.student-stories-slider .swiper-next',
                prevEl: '.student-stories-slider .swiper-prev',
            },
        });
    }

    initHeadshotCards() {
        const headshotCards = document.querySelectorAll('.college-headshot-card');
        if(headshotCards.length > 0) {
            headshotCards.forEach((headshot) => {
                const headshotCard = new HeadshotCollegeCard(headshot);
            });
        }
    }
}

export default PageCollegeTalent;
